/**
 * Kody ustawień publicznych
 *
 * @export
 * @enum {number}
 */
export enum PublicSettings {
  ARCHIVE_STATUSES = 'ARCHIVE_STATUSES',
  ATTACHMENTS_SHOW_RADIO = 'ATTACHMENTS_SHOW_RADIO',
  CHILD_PROCEDURE_ID = 'CHILD_PROCEDURE_ID',
  COLUMNS = 'COLUMNS',
  DECISION_DATA_DATES_DICTIONARY = 'DECISION_DATA_DATES_DICTIONARY',
  DOCUMENT_ATTACHMENT_VIEW_IDS = 'DOCUMENT_ATTACHMENT_VIEW_IDS',
  DOCUMENT_RENDER_OPTIONS = 'DOCUMENT_RENDER_OPTIONS',
  DOCUMENT_VIEW_ID = 'DOCUMENT_VIEW_ID',
  FILTERS = 'FILTERS',
  FINANCIAL_REPORT_COLUMNS = 'FINANCIAL_REPORT_COLUMNS',
  GDPR_INFO_CLAUSE = 'GDPR_INFO_CLAUSE',
  GDPR_POLICY = 'GDPR_POLICY',
  HIDE_DOCUMENT_DOCUMENTATION_FOR_JO = 'HIDE_DOCUMENT_DOCUMENTATION_FOR_JO',
  HIDE_DOCUMENT_GENERATE_FOR_JO = 'HIDE_DOCUMENT_GENERATE_FOR_JO',
  HIDE_PROCEDURE_DOCUMENTATION = 'HIDE_PROCEDURE_DOCUMENTATION',
  HIDE_PROCEDURE_DOCUMENTATION_FOR_JO = 'HIDE_PROCEDURE_DOCUMENTATION_FOR_JO',
  HIDE_PROCEDURE_GENERATE_FOR_JO = 'HIDE_PROCEDURE_GENERATE_FOR_JO',
  KSAT_DISABLED = 'KSAT_DISABLED',
  OLD_STRUCTURE_NODE_MAPPING = 'OLD_STRUCTURE_NODE_MAPPING',
  OW_003_MAX_AMOUNT = 'OW_003_MAX_AMOUNT',
  PACK_CREATE_SHOW = 'PACK_CREATE_SHOW',
  PACK_ENABLED = 'PACK_ENABLED',
  PAYMENT_COLUMNS = 'PAYMENT_COLUMNS',
  PAYMENT_LIST_TYPES = 'PAYMENT_LIST_TYPES',
  PAYMENT_NO_SPLIT = 'PAYMENT_NO_SPLIT',
  PROCEDURE_ATTACHMENT_COLUMN_NAME = 'PROCEDURE_ATTACHMENT_COLUMN_NAME',
  PROCEDURE_ATTACHMENT_SUBDOCUMENT_NAME = 'PROCEDURE_ATTACHMENT_SUBDOCUMENT_NAME',
  PROCEDURE_DOCUMENT_DETAILS_BREADCRUMB = 'PROCEDURE_DOCUMENT_DETAILS_BREADCRUMB',
  PROCEDURE_DOCUMENT_EDIT_BREADCRUMB = 'PROCEDURE_DOCUMENT_EDIT_BREADCRUMB',
  PROCEDURE_EDITABLE_DOCUMENT_VALUE_CODES = 'PROCEDURE_EDITABLE_DOCUMENT_VALUE_CODES',
  PROCEDURE_GET_PDF_BUTTON_TEXT = 'PROCEDURE_GET_PDF_BUTTON_TEXT',
  PROCEDURE_TABLE_BUTTONS = 'PROCEDURE_TABLE_BUTTONS',
  PROCEDURE_TABS = 'PROCEDURE_TABS',
  PROCEDURE_VIEW_IDS = 'PROCEDURE_VIEW_IDS',
  PROCEDURE_WITHOUT_INFO = 'PROCEDURE_WITHOUT_INFO',
  RENDER_EMPTY_OPTIONS = 'RENDER_EMPTY_OPTIONS',
  RENDER_VIEW_OPTIONS = 'RENDER_VIEW_OPTIONS',
  REPORT_COLUMNS = 'REPORT_COLUMNS',
  REPORT_FILTERS = 'REPORT_FILTERS',
  REPORT_GROUPS = 'REPORT_GROUPS',
  SIDE_MENU = 'SIDE_MENU',
  STATISTICS_COLUMNS = 'STATISTICS_COLUMNS',
  SUBMIT_BUTTON_TEXT = 'SUBMIT_BUTTON_TEXT',
  SUBMITTED_MANUALLY_TEXT = 'SUBMITTED_MANUALLY_TEXT',
  SYSTEM_MESSAGE_ENTITY_ROUTE_QUERY = 'SYSTEM_MESSAGE_ENTITY_ROUTE_QUERY'
}
